import { dashboardActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    date: undefined,
    loadingSchedule: false,
    loadingTodaysSchedule: false,
    loadingOutstandingNotes: false,
    showCxNs: true,
    showUnavailable: false,
    openEvalPdf: false,
};


export const reducer = createReducer(initialState, {
    [dashboardActions.loadScheduleRequest]: (state, action) => {
        state.loadingSchedule = true;
    },
    [dashboardActions.loadScheduleSuccess]: (state, action) => {
        state.date = new Date(action.payload.date.setHours(0, 0, 0, 0));
        state.loadingSchedule = false;
    },
    [dashboardActions.loadScheduleFailure]: (state, action) => {
        state.loadingSchedule = false;
    },
    [dashboardActions.loadUserPreferencesSuccess]: (state, action) => {
        state.openEvalPdf = action.payload.response;
    },
    [dashboardActions.saveUserPreferencesSuccess]: (state, action) => {
        state.openEvalPdf = action.payload;
    },
    [dashboardActions.loadTodaysScheduleRequest]: (state, action) => {
        state.loadingTodaysSchedule = true;
    },
    [dashboardActions.loadTodaysScheduleSuccess]: (state, action) => {
        state.loadingTodaysSchedule = false;
    },
    [dashboardActions.loadTodaysScheduleFailure]: (state, action) => {
        state.loadingTodaysSchedule = false;
    },
    [dashboardActions.loadOutstandingNotesRequest]: (state, action) => {
        state.loadingOutstandingNotes = true;
    },
    [dashboardActions.loadOutstandingNotesSuccess]: (state, action) => {
        state.loadingOutstandingNotes = false;
    },
    [dashboardActions.loadOutstandingNotesFailure]: (state, action) => {
        state.loadingOutstandingNotes = false;
    },
    [dashboardActions.flipShowCxNs]: (state, action) => {
        state.showCxNs = !state.showCxNs;
    },
    [dashboardActions.flipShowUnavailable]: (state, action) => {
        state.showUnavailable = !state.showUnavailable;
    },
})